function Footer() {
  return (
    <div>
      <center>
        <hr />
        <h5>
          Made with 💖{" "}
          <a
            href="https://github.com/snowbit-coderboi"
            target="_blank"
            rel="noreferrer"
            style={{ textDecoration: "none", color: "#000", fontWeight: "700" }}
          >
            SnowBit
          </a>{" "}
        </h5>
      </center>
    </div>
  );
}
export default Footer;
